import script from "./ServicesMpSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesMpSection.vue?vue&type=script&setup=true&lang=js"

import "./ServicesMpSection.vue?vue&type=style&index=0&id=6924fd52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6924fd52"]])

export default __exports__